import MainPage from 'pages/MainPage';
import AttentionPage from 'pages/AttentionPage';
import PageNotFound from 'components/PageNotFound';
import BaseLayout from 'layouts/BaseLayout';
import { createBrowserRouter } from 'react-router-dom';
import TermAndConditionPage from 'pages/TermAndConditionPage';
import ManagementPage from 'pages/ManagementPage';
import RegisterPage from 'pages/RegisterPage';
import RegisterSuccessPage from 'pages/RegisterSuccessPage';
import ReconfirmationSuccessPage from 'pages/ReconfirmationSuccessPage';
import ReconfirmationRejectPage from 'pages/ReconfirmationRejectPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />
  },
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/attention',
        element: <AttentionPage />
      },
      {
        path: '/term',
        element: <TermAndConditionPage />
      },
      {
        path: '/registration',
        element: <RegisterPage />
      },
      {
        path: '/management',
        element: <ManagementPage />
      },
      {
        path: '/registration/success',
        element: <RegisterSuccessPage />
      },
      {
        path: '/reconfirmation/:submissionId/success',
        element: <ReconfirmationSuccessPage />
      },
      {
        path: '/reconfirmation/:submissionId/reject',
        element: <ReconfirmationRejectPage />
      }
    ]
  },
  {
    path: '*',
    element: <BaseLayout />,
    children: [
      {
        path: '*',
        element: <PageNotFound />
      }
    ]
  }
]);

export default router;
